import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 各子组件引入
import cockpit from "./tab/cockpit";
import maintenance from "./tab/maintenance";
import ai from "./tab/ai";
import siteInfo from "./tab/siteInfo";
import moment from 'moment';
import { queryBigDataById } from '@/api/api';
import { getAction } from '@/api/manage';
import { mapActions } from 'vuex';
import { ACCESS_TOKEN } from '@/store/mutation-types'; // 全屏

import screenfull from 'screenfull';
import store from "../../../../store";
import { encryption } from '@/utils/encryption/aesEncrypt';
import Vue from 'vue';
export default {
  components: {
    cockpit: cockpit,
    maintenance: maintenance,
    ai: ai,
    siteInfo: siteInfo
  },
  data: function data() {
    return {
      // 青岛大屏免密登录
      showTab: true,
      isSilentLogin: false,
      //是否静默登录
      titleLogo: '',
      waterName: '',
      headDate: '',
      headTime: '',
      selectIndex: 0,
      selectId: 0,
      isFullscreen: false,
      tabList: [{
        id: 0,
        name: '驾驶舱'
      }, {
        id: 1,
        name: '运维专题'
      }, {
        id: 2,
        name: 'AI专题'
      }, {
        id: 3,
        name: '站点专题'
      }]
    };
  },
  created: function created() {
    var _this = this;

    // 青岛大屏免密登录
    if (this.$route.query.isLogin) {
      this.showTab = false;
      this.isSilentLogin = true;
      window.localStorage.setItem('areaRoot', 47);
      window.localStorage.setItem('mapCenter', '120.327458,36.295457');
      window.localStorage.setItem('waterName', '城阳区智慧农污管控平台');
      window.localStorage.setItem('titleLogo', "".concat(window._CONFIG['domianURL'], "/sys/common/file/view/17949"));
      getAction('/auth/getEncryptedString', {}).then(function (res) {
        var loginParams = {
          username: 'visitor',
          type: 1,
          tenantId: '0',
          password: encryption('visitor@123', res.result.key, res.result.iv)
        };

        _this.Login(loginParams).then(function (res) {
          _this.showTab = true;

          window.onbeforeunload = function () {
            _this.clearStorage();
          };
        });
      });
    }

    this.titleLogo = window.localStorage.getItem('titleLogo');
    this.waterName = window.localStorage.getItem('waterName');

    if (this.$route.query.tab) {
      this.selectIndex = this.tabList.length - 1;
      this.selectId = this.tabList[this.selectIndex].id;
      this.$router.replace({
        query: ''
      });
    }

    console.log('this.$route.query', this.$route.query);

    if (this.$route.query && this.$route.query.selectId) {
      console.log('this.$route.query', this.$route.query);
      sessionStorage.setItem('selectTreeCategory', this.$route.query.category);
      queryBigDataById({
        id: this.$route.query.selectId
      }).then(function (res) {
        if (res.success) {
          sessionStorage.setItem('selectId', JSON.stringify(res.result));
          setTimeout(function () {
            _this.turnTosite(true);
          }, 100);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setInterval(function () {
      var date = new Date();
      _this2.headDate = moment(date).format('YYYY年MM月DD日');
    }, 60000);
    this.getDate();
  },
  beforeDestroy: function beforeDestroy() {
    console.log('beforeDestroy');

    if (this.isSilentLogin) {
      this.clearStorage();
    }
  },
  methods: _objectSpread(_objectSpread({
    // 青岛大屏免密登录
    clearStorage: function clearStorage() {
      this.Logout({}).then(function () {});
      this.$store.commit('SET_TOKEN', '');
      this.$store.commit('SET_PERMISSIONLIST', []);
      Vue.ls.remove(ACCESS_TOKEN);
      window.sessionStorage.removeItem('token');
      window.localStorage.removeItem('areaRoot');
      window.localStorage.removeItem('waterName');
      window.localStorage.removeItem('titleLogo');
      window.localStorage.removeItem('mapCenter');
    },
    turnTosite: function turnTosite(value) {
      if (value) {
        this.selectIndex = this.tabList.length - 1;
        this.selectId = this.tabList[this.selectIndex].id;
      }
    },
    getDate: function getDate() {
      var _this3 = this;

      var date = new Date();
      this.headDate = moment(date).format('YYYY年MM月DD日');
      this.headTime = moment(date).format('HH:mm:ss');
      setInterval(function () {
        var time = new Date();
        _this3.headTime = moment(time).format('HH:mm:ss');

        _this3.$forceUpdate();
      }, 1000);
    },
    // 点击头部导航栏
    onToTab: function onToTab(id, index) {
      this.selectIndex = index;
      this.selectId = id;
    },
    fullscreen: function fullscreen() {
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    },
    goHome: function goHome() {
      if (this.isSilentLogin) return;
      this.$router.push('/monitor/map');
    }
  }, mapActions(['Logout', 'Login'])), {}, {
    logout: function logout() {
      if (this.isSilentLogin) return;
      var that = this;
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk: function onOk() {
          return that.Logout({}).then(function () {
            window.location.href = '/'; //window.location.reload()
          }).catch(function (err) {
            that.$message.error({
              title: '错误',
              description: err.message
            });
          });
        },
        onCancel: function onCancel() {}
      });
    }
  })
};